const LayoutIcon = () => {
	return (
		<svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0.75 0.75L10.75 0.75L10.75 14.0833L0.75 14.0833L0.75 0.75Z"
				stroke="var(--black-color)"
				strokeOpacity="0.85"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M0.75 20.75H10.75V27.4167H0.75L0.75 20.75Z"
				stroke="var(--black-color)"
				strokeOpacity="0.85"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.4167 14.0833H27.4167V27.4167H17.4167V14.0833Z"
				stroke="var(--black-color)"
				strokeOpacity="0.85"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.4167 0.75L27.4167 0.75V7.41667L17.4167 7.41667V0.75Z"
				stroke="var(--black-color)"
				strokeOpacity="0.85"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default LayoutIcon;
